module.exports = __webpack_public_path__ + "img/0220624174100.af5fd083.png";